/* AVORA clearout overrides (draft theme "Clearout Oct 2026" only).
   Loaded with `defer` from layout/theme.liquid, so it runs after the inline
   Appstle / Qikify config scripts and BEFORE their deferred app bundles.
   Remove this file + the <script> tag in theme.liquid to revert. */
(function () {
  // 1) (removed) Appstle "One Time Purchase" pre-select: the Greens / Sea Moss pages no longer render the Appstle widget (Liquid).
  // 2) Qikify Slide Cart: savings / compare-at overrides removed (Oct 22) so no struck "original" prices show; app defaults (off) apply.
  try {
    var q = window.Qsc2Data && window.Qsc2Data.settings && window.Qsc2Data.settings.data;
    if (q) {
      // Qikify's own "Recommended Products" showed full-price Sea Moss ($34.99) right above our $10 offer; hide it on this draft.
      q.sc_recommendation_enable = false;
    }
  } catch (e) {}
  // 3) Greens 1-bag / 2-bag picker: keep the quantity input in sync with the chosen pill.
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.matches || !t.matches('.avora-qty input[type=radio]')) return;
    var wrap = t.closest('.avora-qty');
    var hidden = wrap && wrap.querySelector('input[name=quantity]');
    if (hidden) hidden.value = t.value;
  });
  // 4) Stamped badges on cards re-render after AJAX (filters / quick add).
  document.addEventListener('shopify:section:load', function () {
    try { window.StampedFn && StampedFn.loadBadges && StampedFn.loadBadges(); } catch (e) {}
  });
})();

/* 5) Sea Moss add-on ($10) on the Greens product page: when ticked, add Greens + add-on together. */
(function () {
  var GREENS_PRODUCT = 9783548641561;
  var ADDON_HANDLE = 'sea-moss-clearout-add-on';
  var SET_HANDLE = 'glass-bottle-frother-set';
  window.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('button[name=add]');
    if (!btn) return;
    var form = btn.closest('form[action$="/cart/add"]');
    if (!form) return;
    var scope = btn.closest('section, .quick-add-modal__content, product-info') || document;
    var cb = scope.querySelector('.avora-addon__cb');
    if (!cb || !cb.checked) return;
    ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();
    var fd = new FormData(form);
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(fd.get('id'), 10), quantity: qty }, { id: parseInt(cb.dataset.variantId, 10), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      cb.checked = false;
      ['ajax-cart:added', 'cart:add', 'ajax-cart:changed', 'cart-drawer:open'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { detail: res }));
      });
    }).finally(function () { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); });
  }, true);

  /* 6) Cart guard: the add-on only stays in the cart with Greens (max one add-on per Greens bag). */
  var busy = false;
  function guard() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var greens = 0, anyGreens = 0, addon = null, set = null, updates = {}, n = 0;
      cart.items.forEach(function (i) {
        if (i.product_id === GREENS_PRODUCT) { anyGreens += i.quantity; if (!i.selling_plan_allocation) greens += i.quantity; }
        if (i.handle === ADDON_HANDLE) addon = i;
        if (i.handle === SET_HANDLE) set = i;
      });
      if (addon && addon.quantity > greens) { updates[addon.key] = greens; n++; }
      if (set && anyGreens === 0) { updates[set.key] = 0; n++; }
      if (n) {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }) }).then(function () {
          if (window.location.pathname.indexOf('/cart') === 0) { window.location.reload(); }
          else { document.dispatchEvent(new CustomEvent('avora:cart-updated')); }
        });
      }
    }).catch(function () {}).finally(function () { busy = false; });
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(change|update|clear)/.test(url)) { p.then(function () { setTimeout(guard, 300); }).catch(function () {}); }
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard); else guard();
  window.addEventListener('pageshow', guard);
})();

/* 7) Cart offer block ("Before you check out"): shown in the Qikify drawer and on /cart, just above Checkout,
      only when Sunrise Greens is in the cart. Each offer hides once it is in the cart. */
(function () {
  var GREENS_PRODUCT = 9783548641561;
  var OFFERS = [
    { key: 'seamoss', handle: 'sea-moss-clearout-add-on', variant: 67882218651929, oneTimeGreensOnly: true,
      title: 'Add Organic Sea Moss \u2014 $10', sub: 'Usually $34.99' },
    { key: 'set', handle: 'glass-bottle-frother-set', variant: 67882243817753,
      title: 'Add Glass Bottle + Frother Set \u2014 $20', sub: 'Glass bottle, bamboo lid + handheld frother' }
  ];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var avail = {};   // handle -> true/false (product live + in stock)
  var imgs = {};    // handle -> featured image URL from the product's own JSON (Shopify CDN)
  var cart = null, adding = false, timer = null;
  var _fetch = window.fetch.bind(window);

  function checkAvail(o) {
    if (o.handle in avail) return Promise.resolve();
    return _fetch(ROOT + 'products/' + o.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        avail[o.handle] = !!(p && p.available);
        var src = p && (p.featured_image || (p.images && p.images[0]));
        if (src) { if (src.indexOf('//') === 0) src = 'https:' + src; imgs[o.handle] = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=128&height=128&crop=center'; }
      })
      .catch(function () { avail[o.handle] = false; });
  }
  function load() {
    return Promise.all([_fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })]
      .concat(OFFERS.map(checkAvail))).then(function (res) { cart = res[0]; render(); }).catch(function () {});
  }
  function state() {
    var s = { greens: 0, oneTime: 0, inCart: {} };
    if (!cart) return s;
    cart.items.forEach(function (i) {
      if (i.product_id === GREENS_PRODUCT) { s.greens += i.quantity; if (!i.selling_plan_allocation) s.oneTime += i.quantity; }
      OFFERS.forEach(function (o) { if (i.handle === o.handle) s.inCart[o.key] = (s.inCart[o.key] || 0) + i.quantity; });
    });
    return s;
  }
  function html(s) {
    var rows = OFFERS.map(function (o) {
      if (s.inCart[o.key]) return '';
      if (o.oneTimeGreensOnly && s.oneTime < 1) return '';
      var live = avail[o.handle];
      if (!live) return '';   // product not active / sold out -> row hidden (same in preview and live)
      var th = imgs[o.handle] ? '<img class="avora-co__thumb" src="' + imgs[o.handle] + '" alt="" width="60" height="60" loading="lazy" decoding="async">' : '<span class="avora-co__thumb avora-co__thumb--empty" aria-hidden="true"></span>';
      return '<div class="avora-co__row" data-offer="' + o.key + '">' + th + '<div class="avora-co__txt"><strong>' + o.title + '</strong><small>' +
        o.sub + '</small></div>' +
        '<button type="button" class="avora-co__btn" data-variant="' + o.variant + '">Add</button></div>';
    }).join('');
    if (!rows) return '';
    return '<p class="avora-co__head">Before you check out</p>' + rows;
  }
  function mount(anchor, cls) {
    if (!anchor || !anchor.parentNode) return;
    var box = anchor.parentNode.querySelector(':scope > .avora-co');
    var s = state(), h = (s.greens > 0) ? html(s) : '';
    if (!h) { if (box) box.remove(); return; }
    if (!box) { box = document.createElement('div'); box.className = 'avora-co ' + cls; anchor.parentNode.insertBefore(box, anchor); }
    if (box.getAttribute('data-h') !== h) { box.innerHTML = h; box.setAttribute('data-h', h); }
  }
  function render() {
    mount(document.querySelector('.qsc2-drawer-footer__checkout__main-section'), 'avora-co--drawer');
    mount(document.querySelector('#main-cart-footer .cart__ctas'), 'avora-co--page');
  }
  function refreshSoon(ms) { clearTimeout(timer); timer = setTimeout(load, ms || 350); }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('.avora-co__btn');
    if (!btn || btn.disabled || adding) return;
    ev.preventDefault(); ev.stopPropagation();
    adding = true; btn.disabled = true; btn.textContent = 'Adding\u2026';
    // Use the page's (possibly app-wrapped) fetch so Qikify sees the add and redraws the drawer.
    window.fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        ['ajax-cart:added', 'cart:add', 'ajax-cart:changed', 'cart:refresh'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { detail: res })); });
        refreshSoon(600);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add'; refreshSoon(100); })
      .finally(function () { adding = false; });
  }, true);

  // Re-check after any cart change (Qikify / theme / our own guard).
  var wrapped = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = wrapped.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) { p.then(function () { refreshSoon(500); }).catch(function () {}); }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) { this.addEventListener('loadend', function () { refreshSoon(500); }); }
    return _open.apply(this, arguments);
  };
  document.addEventListener('avora:cart-updated', function () { refreshSoon(200); });
  // Qikify re-renders its drawer (Vue); keep our block mounted above Checkout.
  var mo = new MutationObserver(function () {
    var a = document.querySelector('.qsc2-drawer-footer__checkout__main-section');
    if (a && !a.parentNode.querySelector(':scope > .avora-co')) { cart ? render() : null; refreshSoon(250); }
  });
  function start() { mo.observe(document.body, { childList: true, subtree: true }); load(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function () { refreshSoon(100); });
})();
